import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { createKPIAlert, createKPIAlertForOran } from '@api/kpiAlerts';

import { TOnSuccessOnError } from '@interfaces/common/handlers';
import { ICreateKpiAlertDTO } from '@interfaces/kpi/dto/kpiAlertsDTO';

import { EVendorsValues, TVendorsValues } from '@enums/common';

import { CREATE_KPI_ALERT, KPI_ALERTS, KPI_ALERTS_ORAN } from '@constants/queryKeys';

export interface IUseCreateKpiAlertReturnedValues {
	createKpiAlertRule: (data: ICreateKpiAlertDTO) => void;
	isLoadingCreateKpiAlertRule: boolean;
}

interface ICreateKpiAlertParams extends TOnSuccessOnError {
	vendor?: TVendorsValues;
}

export function useCreateKpiAlert({
	onSuccess,
	onError,
	vendor,
}: ICreateKpiAlertParams): IUseCreateKpiAlertReturnedValues {
	const queryClient = useQueryClient();

	const createFn = vendor === EVendorsValues.oran
		? createKPIAlertForOran
		: createKPIAlert;

	const {
		mutate,
		isLoading: isLoadingCreateKpiAlertRule,
	} = useMutation<ICreateKpiAlertDTO>({
		mutationKey: [CREATE_KPI_ALERT],
		mutationFn: createFn,
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [
				queryClient.invalidateQueries([KPI_ALERTS]),
				queryClient.invalidateQueries([KPI_ALERTS_ORAN]),
			];
		},
		onError: () => {
			if (onError) onError();
		},
	});

	return { createKpiAlertRule: mutate, isLoadingCreateKpiAlertRule };
}
